import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { ErrorScreen, NotFoundScreen } from '@/components/error-screen';

export interface RouterContext {
	queryClient: QueryClient;
}

/**
 * Корінь нічого не малює: каркас оператора — у `_operator`, вхід — окремий
 * екран. Тут лише останній рубіж для помилок поза ними.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
	component: Outlet,
	errorComponent: ({ error }) => <ErrorScreen error={error} />,
	notFoundComponent: NotFoundScreen,
});
